module.exports = {
	"base": {
		"welcome": "Benvenuto/a in Mulligan, %{name}.",
		"user": "Informazioni utente",
		"devices": "Dispositivi",
		"refunds": "Rimborsi",
		"resources": "Risorse",
		"transactions": "Transazioni e rimborsi",
		"email": "E-mail",
		"password": "Password",
		"save": "Salva",
		"sign-out": "Disconnetti",
		"cancel": "Annulla",
		"close": "Chiudi",
		"learn-more": "Ulteriori informazioni",
		"required": "Richiesto",
		"support": "Supporto",
		"bookshelf": "Bookshelf",
		"launch": "Avvia",
		"download": "Download",
		"details": "Dettagli",
		"cannot-be-blank": "Il campo %{field} non può essere vuoto.",
		"saving": "Salvataggio in corso…",
		"done": "Fine",
		"failed": "Non riuscito",
		"copy": "Copia"
	},
	"signin": {
		"login-failure": "L'e-mail o la password non è corretta",
		"welcome-large": "Benvenuto <span class='inner'>nell'Account Center di %{brand}</span>",
		"welcome-small": "<span class='inner'>Account Center</span>",
		"signin-button": "Accedi",
		"forgot-password": "Password dimenticata",
		"new-to-vst": "Sei un nuovo utente di %{brand}?",
		"create-account": "Crea un account",
		"signing-in": "Accesso...",
		"signin-failed": "Accesso non riuscito"
	},
	"transactions": {
		"price": "Prezzo",
		"excluded": "(Tasse escluse)",
		"quantity": "Quantità",
		"confirmation#": "Conferma n.",
		"payment": "Pagamento",
		"purchased": "Acquistati",
		"purchase-details": "Dettagli acquisto",
		"subtotal": "Totale parziale",
		"total": "Totale",
		"tax": "Imposta",
		"loading": "Ehi, spendaccione, stiamo caricando le tue transazioni...",
		"no-purchases": "Non hai effettuato acquisti.",
		"seller-vat": "IVA del venditore",
		"total-vat": "Totale %{vat} pagata",
		"portion": "%{subTax} Tassa %{rate}%",
		"vat-disclosure": "Il prezzo include %{vat}",
		"purchases": "Acquisti",
		"refunded-items": "Articoli rimborsati",
		"book-title": "Titolo del libro",
		"refund-details": "Dettagli rimborso",
		"print-receipt": "Stampa ricevuta",
		"request-refund": "Richiesta di rimborso",
		"expired": "Scaduto",
		"expires-in": "Scade il %{date}",
		"details-refund": "Dettagli e rimborso",
		"modal": {
			"cant-refund-title": "Rimborso non disponibile",
			"cant-refund": "Il libro non può essere rimborsato a causa di uno o più dei seguenti motivi.",
			"cant-refund-1": "È stata visualizzata una parte troppo grande del libro.",
			"cant-refund-2": "Sono trascorsi oltre 14 giorni dalla data di acquisto.",
			"cant-refund-3": "Il tuo codice per le risorse online è stato visualizzato.",
			"cant-refund-4": "Il libro è stato rimborsato in precedenza.",
			"cant-refund-5": "Tutti i codici sono già stati riscattati e/o rimborsati.",
			"cant-refund-6": "Sono trascorsi oltre 30 giorni dalla data di acquisto.",
			"cant-refund-support": "Se hai ancora dei dubbi sulla politica di rimborso di %{brand}, contatta <a href='%{support_url}' target='_blank'>il supporto</a>."
		},
		"license": {
			"perpetual": " L'accesso online non ha scadenza",
			"days": "Accesso per %{days} giorno/i"
		}
	},
	"devices": {
		"description": "%{brand} consente di avere <span>%{desktop}</span> computer e <span>%{mobile}</span> dispositivi mobili/tablet attivati contemporaneamente.",
		"loading": "Ehi, stiamo recuperando i tuoi dispositivi :)",
		"no-active": "Non sono presenti dispositivi attivi.",
		"deactivate": "Disattiva"
	},
	"user": {
		"personal-information": "Informazioni personali",
		"security-information": "Informazioni di sicurezza",
		"notifications": "Notifiche",
		"first-name": "Nome",
		"last-name": "Cognome",
		"change-password-title": "Cambia password",
		"current-password": "Password corrente",
		"new-password": "Nuova password",
		"security-password": "Password",
		"confirm-new-password": "Conferma nuova password",
		"security-question": "Domanda di sicurezza",
		"security-info-change": "Modifica",
		"question": "Domanda",
		"answer": "Risposta",
		"notifications-text": "Inviami aggiornamenti saltuari sull'attività del mio account, sui prodotti e sulle offerte speciali.",
		"loading": "Stiamo recuperando le tue informazioni utente, attendi un attimo 🐶",
		"change-password-text": "La password deve essere composta da almeno 8 caratteri e contenere una lettera maiuscola, una lettera minuscola e un carattere speciale.",
		"email-locked": "E-mail bloccata",
		"email-locked-description": "Non si dispone dell'accesso per cambiare l'e-mail. ",
		"email-locked-more": "Contattare l'amministratore.",
		"security-question6": "Qual è il tuo sport preferito?",
		"security-question7": "Qual è il tuo gusto preferito di gelato?",
		"security-question8": "Qual è il nome del tuo animale domestico preferito?",
		"security-question9": "Cosa desideravi diventare da grande?",
		"security-question10": "Qual era il cognome del tuo insegnante?",
		"new-password-failure": "La password non rispetta i requisiti",
		"confirm-password-failure": "La password deve corrispondere",
		"new-password-tooltip": "Deve essere composta da almeno 8 caratteri e contenere una lettera maiuscola, una minuscola e un carattere speciale.",
		"enter-valid-email": "Immetti un indirizzo e-mail valido.",
		"password-cannot-be-same": "La password non può essere identica a quella precedente",
		"incorrect-password": "Password errata",
		"complete-account": "Sembra che tu debba <a href='%{href}'>completare il tuo account</a>.",
		"completing-allows": "Sarai così in grado di leggere libri offline sull'app del tuo dispositivo mobile e condividere con i tuoi amici evidenziazioni e note.",
		"error-updating-info": "There was an error updating your information.",
		"password-updated": "Password successfully updated",
		"security-updated": "Security question successfully updated",
		"info-updated": "User information successfully updated"
	},
	"resources": {
		"ancillaries": "Materiali di sussidio",
		"access-codes": "Codici di accesso",
		"print-on-demand": "Stampa su richiesta",
		"check-pod": "Controlla le opzioni di stampa dell'editore per i propri libri.",
		"check-now": "Controlla ora",
		"loading": "Aspetta, stiamo aggiornando le tue risorse.",
		"in": "in",
		"access-code-intro": "Un codice di accesso è una password che utilizzi per accedere al contenuto di un corso online.  Dopo aver visualizzato un codice per un elemento, non potrai più restituirlo. Per ulteriori istruzioni su come utilizzare i codici di accesso, visita il <a href='%{support_url}' target='_blank'>Supporto</a>.",
		"expires": "Scadenza",
		"expiration-message": "Contiene istruzioni su come utilizzare il codice di accesso.",
		"copy-fail": "Impossibile copiare. Seleziona il codice e copialo manualmente.",
		"launch-site": "Avvia il sito",
		"launch-book": "Avvia libro",
		"reveal-code": "Visualizza codice",
		"no-resources": "Non sono presenti risorse.",
		"no-access-codes": "Non sono presenti codici di accesso.",
		"no-ancillaries": "Non ci sono materiali di sussidio per questo titolo",
		"name": "Nome",
		"type": "Tipo",
		"size": "Dimensione",
		"download-all": "Scarica tutto",
		"back": "Torna alle risorse"
	},
	"refunds": {
		"states": {
			"refunded": "Rimborsato",
			"unavailable": "Rimborso non disponibile"
		},
		"reasons": {
			"dropped": "Ho interrotto il corso",
			"wrong": "Questo era il libro errato per il mio corso",
			"print": "Al suo posto ho deciso di comprare una versione cartacea",
			"missing": "Il libro non contiene tutto ciò di cui ho bisogno per il corso (esempio CD, accesso web e video)",
			"other": "Altro"
		},
		"bulk": {
			"policy": "Facendo clic sul pulsante &quot;Completa il rimborso&quot; di seguito, accetto la <a href='%{policy_url}' target='_blank'>politica di rimborso di %{brand}</a>.",
			"complete": "Completa il rimborso",
			"view-details": "Visualizza i dettagli del rimborso",
			"success": "Il rimborso è stato richiesto. Attendi 48 ore per l'elaborazione.",
			"failure": "Si è verificato un errore. Purtroppo la procedura di rimborso non è stata completata.",
			"retry": "Riprova",
			"support": "Contatta supporto",
			"available-codes": "Codici disponibili",
			"codes-selected": "Codici selezionati",
			"download": "Scarica codici",
			"partially-refunded": "Parzialmente rimborsato",
			"pick-one": "Devi selezionare almeno un codice per effettuare un rimborso"
		},
		"refund": "Rimborso",
		"all": "Rimborsare tutto?",
		"missing-reason": "Devi selezionare un motivo per continuare",
		"missing-elaboration": "Elabora",
		"policy": "Facendo clic sul pulsante \"Completa la richiesta di rimborso\" qui di seguito, prendo atto che se acquistassi nuovamente questo libro di testo digitale %{brand} non avrei più diritto a richiedere qualsiasi ulteriore rimborso per lo stesso libro di testo digitale. Visualizza la politica di rimborso completa.",
		"refunded": "Rimborsato",
		"sorry": "Ci dispiace che il tuo acquisto non ti abbia soddisfatto.",
		"error": "Si è verificato un errore",
		"error-explain": "Il tuo rimborso non è stato elaborato. Riprova.",
		"why": "Facci sapere perché.",
		"no-refunds": "Non sono presenti elementi rimborsati.",
		"select-codes": "Seleziona il/i codice/i da rimborsare:",
		"number": "Quanti?",
		"back": "Torna ai rimborsi"
	},
	"purchases": {
		"back": "Torna agli acquisti"
	},
	"global-bar": {
		"account": "Impostazioni account"
	}
};


/*****************
 ** WEBPACK FOOTER
 ** ./src/locales/it.json
 ** module id = 989
 ** module chunks = 0
 **/